import type { SessionMinutes } from "@repo/contract/training";
import {
  "profile-editors.session_limit_label" as limitLabel,
  "onboarding.session_minutes.question" as minutesQuestion,
} from "@repo/i18n";
import { useCallback } from "react";
import { ChoiceList, Segmented } from "../../../ui/controls";
import {
  type HardLimit,
  hardLimitOptions,
  type SessionMinutesChoice,
  sessionMinutesOptions,
} from "./options";
import { FieldLabel } from "./parts";

export interface SessionMinutesDraft {
  readonly hardLimit: boolean;
  readonly minutes: SessionMinutes;
}

export interface SessionMinutesFormProps {
  onChange: (value: SessionMinutesDraft) => void;
  value: SessionMinutesDraft;
}

/**
 * How long a session may run, and whether that is a wall or a wish — the
 * contract keeps both (`sessionMinutes`, `sessionMinutesIsHardLimit`), so the
 * one A2 sheet asks both.
 */
export function SessionMinutesForm({
  value,
  onChange,
}: SessionMinutesFormProps) {
  const setMinutes = useCallback(
    (choice: SessionMinutesChoice) =>
      onChange({ ...value, minutes: Number(choice) as SessionMinutes }),
    [onChange, value]
  );
  const setLimit = useCallback(
    (limit: HardLimit) => onChange({ ...value, hardLimit: limit === "hard" }),
    [onChange, value]
  );
  return (
    <div>
      <ChoiceList
        label={minutesQuestion()}
        onValueChange={setMinutes}
        options={sessionMinutesOptions()}
        value={String(value.minutes) as SessionMinutesChoice}
      />
      <div className="mt-6">
        <FieldLabel>{limitLabel()}</FieldLabel>
        <Segmented
          label={limitLabel()}
          onValueChange={setLimit}
          options={hardLimitOptions()}
          value={value.hardLimit ? "hard" : "preference"}
        />
      </div>
    </div>
  );
}
